import type { Context } from 'react'
import { createContext } from 'react'
import type { SubheaderTabContextValues } from 'redesign/components/organisms/headers/tabs-header/types'
import { SUBHEADER_TAB_CONTEXT_INITIAL_VALUES } from './constants'

const SubheaderTabContext: Context<SubheaderTabContextValues> = createContext(
  SUBHEADER_TAB_CONTEXT_INITIAL_VALUES as SubheaderTabContextValues,
)

export default SubheaderTabContext
